theme.headerMainMenuModule = (function () {
  function mainMenu(container) {
    var headerWrapper = container.querySelector('.header_bottom');
    var menuItems = Array.prototype.slice.call(
      container.querySelectorAll('.header__menu_li.menu__item_has_children')
    );
    var OPEN_DELAY = 80;
    var CLOSE_DELAY = 250;
    var openTimer = null;
    var closeTimer = null;

    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function closeItem(item) {
      var details = item.querySelector('details');
      var summary = item.querySelector('summary');
      if (!details || !summary) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      var details = item.querySelector('details');
      var summary = item.querySelector('summary');
      if (!details || !summary) return;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      if (headerWrapper) headerWrapper.classList.add('mega--menu-open');
    }

    function anyOpen() {
      return menuItems.some(function (item) {
        var details = item.querySelector('details');
        return details && details.hasAttribute('open');
      });
    }

    function closeAll(except) {
      menuItems.forEach(function (item) {
        if (item !== except) closeItem(item);
      });
      if (headerWrapper && !anyOpen()) {
        headerWrapper.classList.remove('mega--menu-open');
      }
    }

    menuItems.forEach(function (item) {
      var details = item.querySelector('details');
      var summary = item.querySelector('summary');
      if (!details || !summary) return;

      summary.setAttribute('aria-haspopup', 'true');
      summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');

      // Mouse: open on hover (with a short delay to avoid accidental triggers),
      // close on mouse leave (with a short delay so moving into the panel doesn't close it).
      item.addEventListener('mouseenter', function () {
        clearTimers();
        openTimer = setTimeout(function () {
          closeAll(item);
          openItem(item);
        }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimers();
        closeTimer = setTimeout(function () {
          closeItem(item);
          if (headerWrapper && !anyOpen()) {
            headerWrapper.classList.remove('mega--menu-open');
          }
        }, CLOSE_DELAY);
      });

      // Keyboard / touch: click or Enter/Space on the summary toggles the panel.
      // This keeps the menu usable for keyboard-only users and touch devices,
      // which don't have a hover state.
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        clearTimers();
        var isOpen = details.hasAttribute('open');
        closeAll(item);
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });

      // Keyboard focus entering the item (e.g. via Tab) opens it, mirroring hover
      // for people who can't use a mouse.
      item.addEventListener('focusin', function () {
        clearTimers();
        closeAll(item);
        openItem(item);
      });

      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          clearTimers();
          closeItem(item);
          if (headerWrapper) headerWrapper.classList.remove('mega--menu-open');
          summary.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      var openItem = menuItems.find(function (item) {
        var details = item.querySelector('details');
        return details && details.hasAttribute('open');
      });
      if (openItem && !openItem.contains(event.target)) {
        clearTimers();
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        clearTimers();
        closeAll();
      }
    });

    document.addEventListener('focusin', function (event) {
      var openItem = menuItems.find(function (item) {
        var details = item.querySelector('details');
        return details && details.hasAttribute('open');
      });
      if (openItem && !openItem.contains(event.target)) {
        clearTimers();
        closeAll();
      }
    });
  }
  return mainMenu;
})();
